import React, { useState } from 'react';
import Input from 'components/common/form/input/Input';
import { Form, Formik } from 'formik';
import { Col, FormGroup, FormLabel, Row } from 'react-bootstrap';
import * as Yup from 'yup';
import Button from 'components/base/Button';
import { FormValues, Props } from './newPasswordForm.type';
import LinkExpiredModal from 'components/modals/LinkExpiredModal';
import { useNavigate } from 'react-router-dom';
import AccountActivatedModal from 'components/modals/AccountActivatedModal';
import useVerifyRecruiter from '../hook/useVerifyRecruiter';

const validationSchema = Yup.object().shape({
  password: Yup.string()
    .required('Password is required')
    .min(8, 'Password must be at least 8 characters long')
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/,
      'Password must contain at least one letter and one number'
    ),

  confirmPassword: Yup.string()
    .required('Confirm password is required')
    .oneOf([Yup.ref('password')], 'Passwords must match')
});

function NewPasswordForm({ token }: Props) {
  const [isSuccess, setIsSuccess] = useState(false);
  const { isLoading, isError, verifyRecruiter } = useVerifyRecruiter(token);
  const navigate = useNavigate();

  const navigateToSignin = () => {
    navigate('/sign-in');
  };

  const handleSubmit = ({ password }: FormValues) => {
    verifyRecruiter({ password }, () => {
      setIsSuccess(true);
    });
  };

  return (
    <div>
      <LinkExpiredModal show={isError} handleSubmit={navigateToSignin} />
      <AccountActivatedModal handleSubmit={navigateToSignin} show={isSuccess} />
      <Formik
        initialValues={{
          password: '',
          confirmPassword: ''
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        <Form>
          <Row className="g-4 justify-content-center">
            <Col xs={10}>
              <FormGroup className="text-start">
                <FormLabel htmlFor="password">Password</FormLabel>
                <Input name="password" id="password" type="password" />
              </FormGroup>
            </Col>
            <Col xs={10}>
              <FormGroup className="text-start">
                <FormLabel htmlFor="confirmPassword">
                  Confirm Password
                </FormLabel>
                <Input
                  name="confirmPassword"
                  id="confirmPassword"
                  type="password"
                />
              </FormGroup>
            </Col>
          </Row>
          <footer className="mt-4 d-flex justify-content-center">
            <Button
              variant="primary"
              type="submit"
              loading={isLoading}
              loadingPosition="start"
            >
              Activate
            </Button>
          </footer>
        </Form>
      </Formik>
    </div>
  );
}

export default NewPasswordForm;
